import Avatar from "react-avatar";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import Loader from "../common/Loader/Loader";
import styles from "./History.module.scss";
const HistoryPage = () => {
  const historyData = useSelector((state) => state.applicant.history);
  const loadingCheck = useSelector((state) => state.applicant.loading);
  return (
    <div className={styles.historyPage}>
      {loadingCheck ? (
        <Loader height={50} width={50} color={"#5382ba"} />
      ) : (
        <Container>
          <div className={styles.historyHeading}>
            <div className={styles.historyNamePart}>
              <div className={`${styles.profileImage}`}>
                <Avatar
                  className={styles.commentAvt}
                  name={historyData?.applicant?.name.split(" ")[0] + historyData?.applicant?.name.split(" "[1]) }
                  size="30"
                  round={true}
                />
              </div>
              <span className={styles.pName}>
                {historyData?.applicant
                  ? historyData?.applicant?.name +
                  " - " +
                  historyData?.applicant?.profile_name
                  : ""}
              </span>
            </div>
          </div>
          <div className={styles.historyMain}>
            {historyData?.result && historyData?.result.length > 0
              ? historyData?.result.map((data, i) => (
                <>
                  <div className={styles.historyDt}>
                    <div className={styles.historyDatePart}>{data.date}</div>
                    {data?.data?.map((val, ind) => (
                      <Row className={styles.hostoryRow}>
                        <Col md="6" sm="12">
                          <div className={styles.historyNamePart}>
                            <div className={`${styles.profileImage}`}>

                              {val?.avtar && val?.avtar?.url ?
                                <Avatar
                                  className={styles.commentAvt}
                                  facebook-id="invalidfacebookusername"
                                  src={val?.avtar?.url}
                                  size="30"
                                  round={true}
                                />
                                : <Avatar
                                  className={styles.commentAvt}
                                  name={val?.name+ " " +val?.lastName}
                                  maxInitials={2}
                                  size="30"
                                  round={true}
                                />
                              }
                            </div>
                            <span className={styles.pName}>
                              {val?.name}{" "}
                              {val?.lastName != null ? val?.lastName : ""}
                              {val?.notes && val?.notes !== null ? (
                                <>
                                  {" "}
                                  -{" "}
                                  <span className={styles.resPart}>
                                    {val?.notes}
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col md="6" sm="12">
                          <div className={styles.historyDataPart}>
                            <div className={styles.StatusText}>
                              {" "}
                              {val?.application_status}
                            </div>
                            <div className={styles.HistoryTime}>
                              {val?.createdTime}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                </>
              ))
              : ""}
          </div>
        </Container>
      )}
    </div>
  );
};

export default HistoryPage;
